import { CustomTemplatedMessageVariables } from 'generated-graphql/types';

export const customTemplatedMessageExampleVariables = ({
  agentName,
  employerName,
  jobTitle,
  organizationName,
  location
}: {
  agentName: string;
  employerName: string;
  jobTitle: string;
  organizationName: string;
  location: string;
}) => ({
  [CustomTemplatedMessageVariables.AgentName]: agentName,
  [CustomTemplatedMessageVariables.CandidateFirstName]: 'Alice',
  [CustomTemplatedMessageVariables.CandidateLastName]: 'Smith',
  [CustomTemplatedMessageVariables.JobTitle]: jobTitle,
  [CustomTemplatedMessageVariables.OrganizationName]: organizationName,
  [CustomTemplatedMessageVariables.Location]: location,
  [CustomTemplatedMessageVariables.EmployerName]: employerName
});

export const SMS_CUSTOM_MESSAGE_MAX_CHARACTERS = 600;
